module.exports = __webpack_public_path__ + "img/free-people.cd74891c.png";